import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";
import { normalizedData } from "@utils";
import Seo from "@components/seo";
import Layout from "@layout";
import Header from "@layout/header/layout-01";
import Footer from "@layout/footer/layout-01";
import PageHeader from "@containers/page-header/layout-02";
import DentalTechnologyArea from "@containers/dental-technology/layout-02";
import ContactArea from "@containers/contact/layout-06";

const DentalTechnologiesPage = ({ pageContext, location, data }) => {
    const content = normalizedData(data?.page?.content || []);
    const globalContent = normalizedData(data?.allGeneral.nodes || []);

    return (
        <Layout location={location}>
            <Seo title="Dental Technologies" />
            <Header
                data={{
                    ...globalContent["header"],
                    ...globalContent["menu"],
                }}
            />
            <main className="site-wrapper-reveal">
                <PageHeader
                    pageContext={pageContext}
                    location={location}
                    title="Dental Technologies"
                />
                <DentalTechnologyArea
                    data={{
                        ...content["service-section"],
                        items: data.allDentalTechnology.nodes,
                    }}
                    bg="white"
                />
                
                <ContactArea
                    data={{
                        ...content["contact-section"],
                        contact: data.site.siteMetadata.contact,
                    }}
                />
            </main>
            <Footer data={{ ...data.site.siteMetadata }} />
        </Layout>
    );
};

export const query = graphql`
    query DentalTechnologiesPageQuery($locale: String!) {
        allGeneral(filter: { locale: { eq: $locale } }) {
            nodes {
                section
                ...HeaderOne
            }
        }
        site {
            ...Site
        }
        page(title: { eq: "dental-techonologies" }, pageType: { eq: "innerpage" }, locale: { eq: $locale }) {
            content {
                ...PageContent
            }
        }
        allDentalTechnology {
            nodes {
                ...DentalTechnologyOne
            }
        }
    }
`;

DentalTechnologiesPage.propTypes = {
    pageContext: PropTypes.shape({}),
    location: PropTypes.shape({}),
    data: PropTypes.shape({
        allGeneral: PropTypes.shape({
            nodes: PropTypes.arrayOf(PropTypes.shape({})),
        }),
        site: PropTypes.shape({
            siteMetadata: PropTypes.shape({
                contact: PropTypes.shape({}),
            }),
        }),
        page: PropTypes.shape({
            content: PropTypes.arrayOf(PropTypes.shape({})),
        }),
        allDentalTechnology: PropTypes.shape({
            nodes: PropTypes.arrayOf(PropTypes.shape({})),
        }),
    }),
};

export default DentalTechnologiesPage;
